import LitePlanIcon from '../images/plans/Lite.svg';
import ProPlanIcon from '../images/plans/Pro.svg';
import ElitePlanIcon from '../images/plans/Elite.svg';
import FreePlanIcon from '../images/plans/Freemium.svg';
import GrowthPlanIcon from '../images/plans/Growth.svg';

const emailSettingsUrl = (id) => (`/app/sharedmailbox/edit/${id}/settings`);
const chatUnavailabilitySettingsUrl = (id) => (`/app/sharedmailbox/chat/edit/${id}/unavailabilitysettings`);

const API_RESPONSE_ERROR_MESSAGE = 'Some error occured. Please contact support@hiverhq.com';

const LINKED_SM_LIST_TITLE_TEXT = 'Any Changes will impact the following Shared Inboxes';

export {
  emailSettingsUrl,
  chatUnavailabilitySettingsUrl,
  API_RESPONSE_ERROR_MESSAGE,
  LINKED_SM_LIST_TITLE_TEXT,
}

export const planName = {
  LITE: 'Lite',
  PRO: 'Pro',
  ELITE: 'Elite',
  FREE: 'Free',
  TRIAL: 'Trial',
  GROWTH: 'Growth'
}

export const PLAN_TYPE = {
  MONTHLY: 'monthly',
  ANNUAL: 'annual',
}

export const planIcons = {
  [planName.PRO]: ProPlanIcon,
  [planName.ELITE]: ElitePlanIcon,
  [planName.LITE]: LitePlanIcon,
  [planName.FREE]: FreePlanIcon,
  [planName.GROWTH]: GrowthPlanIcon,
};

// Billing account types
export const BILLING_ACCOUNT_TYPE = {
  WIRE_TRANSFER: 'wire_transfer',
  CREDIT_CARD: 'credit_card'
}

export const UPGRADE_BUTTON_CLICKED_EVENT = 'clickedUpgrade'
export const ACCOUNTS_PAGE_URL = '/app/settings/account';
export const HIVER_EXTENSION_URL = "chrome-extension://fcinnggknmdfkilogcndkgpojpfojeem"

export const GAINSIGHT_EVENTS = {
  'assign': 'NewReplyAssigned',
  'unassign': 'NewReplyUnassigned',
  'user_control': 'NewReplyChoice'  
}

export const FREEMIUM_PLAN_ID = 31;

export const KEY_PRESS = {
  ENTER: "Enter",
};

export const PAYMENT_CHECKOUT_HUBSPOT_EVENT = {
  SESSION_STARTED: 'payment_checkout_session_started___stripe_event',
  SESSION_ABANDONED: 'payment_abandoned___stripe_event'
};
